module.exports = __webpack_public_path__ + "static/media/ros.63ca0d16.svg";